import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import type { Entity } from '../../types'

const DOC = gql`
  query SpaceUnassignedSponsoredPeoplePayrolls(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $filter: SpacePayrollsFilterInput
    $pagination: SpacePayrollsPaginationInput
    $sort: SpacePayrollsSortInput
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceUnassignedSponsoredPayrolls(
                  filter: $filter
                  pagination: $pagination
                  sort: $sort
                ) {
                  id
                  organization
                  employee {
                    jobTitleId
                    name
                  }
                  unassignedSponsoredPeopleComment
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceUnassignedSponsoredPeoplePayrollsQuery,
    Entity[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'spaceUnassignedSponsoredPayrolls',
                graphql.transformers.OUT.list(
                  graphql.transformers.OUT.object({
                    comment: {
                      usingFullInput: graphql.transformers.OUT.select(
                        'unassignedSponsoredPeopleComment',
                        transformers.PASS_THROUGH,
                      ),
                    },
                    // NOTE: nullable in the schema, but a payroll always has one
                    employee: graphql.transformers.OUT.validate(
                      graphql.transformers.OUT.object<
                        {
                          readonly jobTitleId?: string | null
                          readonly name: string
                        },
                        Entity['employee']
                      >({
                        jobTitleId: graphql.transformers.OUT.nullable(
                          graphql.transformers.OUT.validate(
                            transformers.PASS_THROUGH,
                            ents.extra.space.JobTitle.Id.assertIsId,
                          ),
                        ),
                        name: transformers.PASS_THROUGH,
                      }),
                      TypeAsserter.assertIsNotNullish,
                    ),
                    id: graphql.transformers.OUT.validate(
                      transformers.PASS_THROUGH,
                      ents.core.dms.data.Record.Id.isId,
                    ),
                    // NOTE: served as AWSJSON, so it arrives as a string that
                    // has to be parsed
                    organization: graphql.transformers.OUT.validate(
                      graphql.transformers.OUT.json(),
                      ents.extra.space.Organization.Lookup.assertIsLookup,
                    ),
                  }),
                  { onNullish: 'remove' },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceUnassignedSponsoredPeoplePayrollsQuery,
  Entity[],
  graphql.schema.SpaceUnassignedSponsoredPeoplePayrollsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
